import React from 'react';
import { DeleteIcon, EyeIcon, PencilIcon } from '../../../utils/TableActionIcons';
import CheckPermission from '../../../hooks/CheckPermission';

const FormListItem = ({
  data,
  isViewData = false,
  isAllowActions = true,
  onEditClick = () => {},
  onDeleteClick = () => {},
  onContainerClick = () => {},
  onViewClick = () => {}
}) => {
  const { hasPermission } = CheckPermission();
  return (
    <div className='flex items-center justify-between'>
      <div className='w-full cursor-pointer' onClick={() => onContainerClick(data)}>
        <h5 className='text-14-gray !font-semibold mb-1'>{data?.name_en}</h5>
        <h6 className='text-14-dark capitalize'>{data?.type}</h6>
      </div>
      {isAllowActions && (
        <div className='flex items-center gap-3'>
          {isViewData && <EyeIcon iconSize='17' onClick={() => onViewClick(data)} />}
          {hasPermission('forms-creation', 'update') && <PencilIcon iconSize='17' onClick={() => onEditClick(data)} />}
          {hasPermission('forms-creation', 'delete') && <DeleteIcon iconSize='20' onClick={() => onDeleteClick(data)} />}
        </div>
      )}
    </div>
  );
};

export default FormListItem;
